export const UPDATE_VIEW_TYPE = 'UPDATE_VIEW_TYPE';
export default UPDATE_VIEW_TYPE;
